import React from 'react'
import useDonation from '../hooks/useDonation';
import CustomDonationTable from '../features/donation/components/customDonationTable';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

function DonationManagementPage() {

  type Acknowledgment = {isAcknowledged:boolean}

  const {donationData,aggregateDonation,loading,updateDonation} = useDonation();

  const sendAppreciation = (_id:string,email:string,name:string) =>{
    // console.log('===================Appreciation=====================')
    // console.log('id:',_id);
    // console.log('email',email);
    handleAppreciation(_id);
    window.location.href=`mailto:${email}?subject=Thank%20You%20&body=Hello%20${name}%3A%0D%0A%0D%0`
  }

  const handleAppreciation = async(_id:string) =>{
    // console.log('============Aknowlegment==========')
      const newData:Acknowledgment = {
                      "isAcknowledged":true
                      }

      try {
          const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/donation/update/${_id}`,newData);
          if(res.status===200){
            // console.log('updated data',res.data)
              updateDonation(res.data.data);
              toast.success(" Donor Ackowledged!, Please ensure to send mail", {
                      position: toast.POSITION.TOP_CENTER
              });
          }
          else{
              toast.error(`Error Acknowlegding Donor`, {
                  position: toast.POSITION.TOP_LEFT
                });       
          }
          
       } catch (error) {
          toast.error(`${(error as any).message}`, {
              position: toast.POSITION.TOP_LEFT
            });       
        // console.log('server error',error);
        throw error;
      }
  
  }

  return (
    <div className='pt-2 pr-2 w-full'>
      <p className='mb-2 font-semibold'>DONATION TRACKER</p>
      <p className='font-bold text-end'>Total : {aggregateDonation.totalDonation}GHS</p>

      <CustomDonationTable data={donationData} myFunction={sendAppreciation} loading={loading} actionText={'Send Mail'}/>
      
    </div>
  )
}

export default DonationManagementPage;